<section id="landing-page">
  <div class="content-wrap m-0 p-0">
    <div class="col_full">
      <!-- Country Selection -->
      <div class="m-b-30 first-section">
        <div class="row languages-country">
          <div class="col-md-6 offset-md-6 container-box">
            <div class="text-center m-b-20">
              <div class="main-logo-landing" [style.backgroundImage]="projectCode == 'qp11' ? 'url(/assets/images/logo-white.png)' : 'url(' + logoUrl + ')'"></div>
            </div>
            <!-- <div class="row p-b-30"
              *ngFor="let item of availableCountryAndLanguages[currentDomain]  | keyvalue: returnZero">
              <div class="col-12 d-flex country-langauge justify-content-center">
                <img src="assets/images/language/{{ item.key }}.png" alt="{{ item.value.name }} Flag Icon">
                <div>
                  <h6 class="m-t-15">{{ item.value.name | translate }}</h6>
                  <div class="language-selection-container">
                    <ng-container *ngFor="let code of item.value.languages; let i = index">
                        <a (click)="setLanguage(code, item.key)">{{ languages[code] }}</a>
                    </ng-container>
                  </div>
                  <ng-container *ngIf="item.value.languages.length == 0">
                    <div class="col-12 p-0">
                      <span>{{ 'Coming soon...' | translate }}</span>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div> -->
            <!-- BEFORE LOGIN -->
            <div class="center-content">
              <div class="cta-label">     
                {{ 'Please choose your country and language.' | translate }}
              </div>
              <ng-container *ngIf="isLoggedIn === false; else elseAfterLogin">
                <div class="country-language-list">
                  <div class="row p-b-30" *ngFor="let item of availableCountryAndLanguages[currentDomain] | keyvalue: returnZero">
                    <div class="col-12 d-flex country-langauge">
                      <img src="/assets/images/language/{{ item.key }}.png">
                      <div>
                        <h6 class="m-t-15">{{ item.value.name | translate }}</h6>
                        <div class="language-selection-container">
                          <ng-container *ngFor="let code of item.value.languages; let i = index">
                            <a (click)="setLanguage(code, item.key)"
                              [ngClass]="(currentLanguageCode == code && currentCountryCode == item.key) ? 'selected' : ''">
                              {{ languages[code] }}
                            </a>
                          </ng-container>
                        </div>
                        <ng-container *ngIf="item.value.languages.length == 0">
                            <div class="col-12 p-0">
                                <span>{{ 'Coming soon...' | translate }}</span>
                            </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
          </div>
          <!-- AFTER LOGIN -->
          <ng-template #elseAfterLogin>
            <div class="col-12 d-flex country-langauge justify-content-center">
              <div>
                <img [src]="'/assets/images/language/' + currentCountryCode + '.png'"
                  [alt]="availableCountryAndLanguages[currentDomain][currentCountryCode].name + ' Flag Icon'">
              </div>
              <div>
                <h6>{{ availableCountryAndLanguages[currentDomain][currentCountryCode].name | translate }}</h6>
                <div class="language-selection-container">
                  <ng-container
                    *ngFor="let code of availableCountryAndLanguages[currentDomain][currentCountryCode].languages; let i = index">
                    <a (click)="setLanguage(code, currentCountryCode)"
                      [ngClass]="(currentLanguageCode == code) ? 'selected' : ''">
                      {{ languages[code] }}
                    </a>
                  </ng-container>
                </div>
                <ng-container *ngIf="availableCountryAndLanguages[currentDomain][currentCountryCode].languages.length == 0">
                    <div class="col-12 p-0">
                        <span>{{ 'Coming soon...' | translate }}</span>
                    </div>
                </ng-container>
              </div>
            </div>
          </ng-template>
          </div>
        </div>
      </div>

      <div class="container" id="section1">
        <div class="our-games">
          <h1 class="section-title">{{'Our games' | translate | uppercase}}</h1>
          <p>{{'[site_prefix] has been Asia’s most influential and trusted online gaming platform since 2019. We provide a breath of fresh air into your online gaming experience and do so by partnering with the best gaming vendors that enable a wide range of top-notch games in various categories!' | translate:{'site_prefix':siteName} }}  </p>
        </div>
        <div  *ngIf="categorylocales.length == 0"  class="text-center container m-b-100">
          <span class="spinner-border spinner-border-sm mm-t-5" aria-hidden="true"></span>
        </div>  
        <ng-container *ngIf="categorylocales.length > 0 && !isSkeletonGameCategory; else skeletonGameCategory">
          <div class="row all-categories" [ngStyle]="isQP17b || isQP22 || isQP23 ? {
              'display': 'flex',
              'flex-wrap': 'wrap',
              'justify-content': 'center'
            } : {}" *ngIf="categorylocales.length > 0">
            <ng-container class="container m-b-100" >
              <ng-container *ngFor="let categorylocale of categorylocales">
                <ng-container *ngIf="categorylocale.code == 'LC' && availableProvider[categorylocale.code] && availableProvider[categorylocale.code].length > 0">
                  <div class="col-4">
                    <img src="/assets/images/landing/casino.png" class="img-fluid">
                    <div class="category-box">
                      <h3>{{ categorylocale.title | uppercase}}</h3>
                      <p>{{ categorylocale.description }}</p>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="categorylocale.code == 'SL' && availableProvider[categorylocale.code] && availableProvider[categorylocale.code].length > 0">
                  <div class="col-4">
                    <img src="/assets/images/landing/slot.png" class="img-fluid">
                    <div class="category-box">
                      <h3>{{ categorylocale.title | uppercase}}</h3>
                      <p>{{ categorylocale.description }}</p>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="categorylocale.code == 'FS' && availableProvider[categorylocale.code] && availableProvider[categorylocale.code].length > 0">
                  <div class="col-4">
                    <img  src="/assets/images/landing/fishing.png" class="img-fluid">
                    <div class="category-box">
                      <h3>{{ categorylocale.title | uppercase}}</h3>
                      <p>{{ categorylocale.description }}</p>
                    </div>
                  </div>
                </ng-container>
                
                <ng-container *ngIf="categorylocale.code == 'SP' && availableProvider[categorylocale.code] && availableProvider[categorylocale.code].length > 0">
                  <div class="col-4">
                    <img src="/assets/images/landing/sport.png" class="img-fluid">
                    <div class="category-box">
                      <h3>{{ categorylocale.title | uppercase}}</h3>
                      <p>{{ categorylocale.description }}</p>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="categorylocale.code == 'ES' && availableProvider[categorylocale.code] && availableProvider[categorylocale.code].length > 0">
                  <div class="col-4">
                    <img src="/assets/images/landing/esports.png" class="img-fluid">
                    <div class="category-box">
                      <h3>{{ categorylocale.title | uppercase}}</h3>
                      <p>{{ categorylocale.description }}</p>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngIf="categorylocale.code == 'CK' && availableProvider[categorylocale.code] && availableProvider[categorylocale.code].length > 0">
                  <div class="col-4">
                    <img src="/assets/images/landing/crickets.png" class="img-fluid">
                    <div class="category-box">
                      <h3>{{ categorylocale.title | uppercase}}</h3>
                      <p>{{ categorylocale.description }}</p>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="categorylocale.code == 'LT' && availableProvider[categorylocale.code] && availableProvider[categorylocale.code].length > 0">
                  <div class="col-4">
                    <img src="/assets/images/landing/lottery.png" class="img-fluid">
                    <div class="category-box">
                      <h3>{{ categorylocale.title | uppercase}}</h3>
                      <p>{{ categorylocale.description }}</p>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="categorylocale.code == 'CF' && availableProvider[categorylocale.code] && availableProvider[categorylocale.code].length > 0">
                  <div class="col-4">
                    <img src="/assets/images/landing/cockfight.png" class="img-fluid">
                    <div class="category-box">
                      <h3>{{ categorylocale.title | uppercase}}</h3>
                      <p>{{ categorylocale.description }}</p>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="categorylocale.code == 'CG' && availableProvider[categorylocale.code] && availableProvider[categorylocale.code].length > 0">
                  <div class="col-4">
                    <img src="/assets/images/landing/crash-game.png" class="img-fluid">
                    <div class="category-box">
                      <h3>{{ categorylocale.title | uppercase}}</h3>
                      <p>{{ categorylocale.description }}</p>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="categorylocale.code == 'TB' && availableProvider[categorylocale.code] && availableProvider[categorylocale.code].length > 0">
                  <div class="col-4">
                    <img src="/assets/images/landing/table.png" class="img-fluid">
                    <div class="category-box">
                      <h3>{{ categorylocale.title | uppercase}}</h3>
                      <p>{{ categorylocale.description }}</p>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>

            <!-- <div class="col-4"> -->
              <!-- <img src="/assets/images/landing/casino.png" class="img-fluid"> -->
              <!-- <div class="category-box"> -->
                <!-- <h3>{{'Casino' | translate | uppercase}}</h3> -->
                <!-- TODO
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p> -->
              <!-- </div> -->
            <!-- </div> -->
            <!-- <div class="col-4"> -->
              <!-- <img src="/assets/images/landing/slot.png" class="img-fluid"> -->
              <!-- <div class="category-box"> -->
                <!-- <h3>{{'Slots' | translate | uppercase}}</h3> -->
                <!-- TODO -->
                <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p> -->
              <!-- </div> -->
            <!-- </div> -->
            <!-- <div class="col-4"> -->
              <!-- <img src="/assets/images/landing/fishing.png" class="img-fluid"> -->
              <!-- <div class="category-box"> -->
                <!-- <h3>{{'Fishing' | translate | uppercase}}</h3> -->
                <!-- TODO -->
                <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p> -->
              <!-- </div> -->
            <!-- </div> -->
            <!-- <div class="col-4"> -->
              <!-- <img src="/assets/images/landing/sport.png" class="img-fluid"> -->
              <!-- <div class="category-box"> -->
                <!-- <h3>{{'Sports' | translate | uppercase}}</h3> -->
                <!-- TODO -->
                <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p> -->
              <!-- </div> -->
            <!-- </div> -->
            <!-- <div class="col-4"> -->
              <!-- <img src="/assets/images/landing/esports.png" class="img-fluid"> -->
              <!-- <div class="category-box"> -->
                <!-- <h3>{{'Esports' | translate | uppercase}}</h3> -->
                <!-- TODO -->
                <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p> -->
              <!-- </div> -->
            <!-- </div> -->
            <!-- <div class="col-4"> -->
              <!-- <img src="/assets/images/landing/crickets.png" class="img-fluid"> -->
              <!-- <div class="category-box"> -->
                <!-- <h3>{{'Crickets' | translate | uppercase}}</h3> -->
                <!-- TODO -->
                <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p> -->
              <!-- </div> -->
            <!-- </div> -->
            <!-- <div class="col-4"> -->
              <!-- <img src="/assets/images/landing/lottery.png" class="img-fluid"> -->
              <!-- <div class="category-box"> -->
                <!-- <h3>{{'Lottery' | translate | uppercase}}</h3> -->
                <!-- TODO -->
                <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p> -->
              <!-- </div> -->
            <!-- </div> -->
              <!-- </div>
            </div>
            <div class="col-4">
              <img src="/assets/images/landing/lottery.png" class="img-fluid">
              <div class="category-box">
                <h3>{{'Lottery' | translate | uppercase}}</h3> -->
                <!-- TODO -->
                <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p> -->
              <!-- </div>
            </div>
            <div class="col-4">
              <img src="/assets/images/landing/crash-game.png" class="img-fluid">
              <div class="category-box">
                <h3>{{'Crash Game' | translate | uppercase}}</h3> -->
                <!-- TODO -->
                <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p> -->
              <!-- </div>
            </div>
            <div class="col-4">
              <img src="/assets/images/landing/table.png" class="img-fluid">
              <div class="category-box">
                <h3>{{'Table' | translate | uppercase}}</h3> -->
                <!-- TODO -->
                <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p> -->
              <!-- </div> -->
            <!-- </div> -->
          </div>
        </ng-container>

        <ng-template #skeletonGameCategory>
          <ng-container *ngIf="isSkeletonGameCategory">
            <div class="row all-categories">
              <ng-container *ngFor="let item of [].constructor(6); let i = index">
                <div class="col-4">
                  <div class="skeleton skeleton-category-image"></div>
                  <div class="category-box">
                    <h3 class="skeleton skeleton-title"></h3>
                    <ng-container *ngFor="let item of [].constructor(3); let i = index">
                      <p class="skeleton skeleton-text"></p>
                    </ng-container>
                  </div>
                </div> 
              </ng-container>
            </div>
          </ng-container>
        </ng-template>

          <!-- USP Section -->
          <ng-container *ngIf="usps.length > 0 && !isSkeletonUsps; else skeletonUsps">
            <div class="container m-b-100">
              <div class="row justify-content-center">
                  <div *ngIf="uspMainContent" class="col-12">
                    <h1 class="section-title">{{ uspMainContent.content | uppercase }}</h1>
                  </div>
                  <ng-container>
                    <div class="col-4" *ngFor="let usp of usps">
                      <div class="why-us-box" [ngClass]="{ 'gradient-bg': isQP17b }">
                          <span [innerHTML]="usp.svg_icon | safeHtml"></span>
                          <h3>{{ usp.title | uppercase }}</h3>
                          <p>{{ usp.content }}</p>
                      </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>

          <!-- Skeleton Loading -->
          <ng-template #skeletonUsps>
            <ng-container *ngIf="isSkeletonUsps">
              <div class="container m-b-100">
                <div class="row justify-content-center">
                  <div class="col-12">
                    <h1 class="section-title skeleton skeleton-category-title "></h1>
                  </div>
                  <ng-container *ngFor="let item of [].constructor(3); let i = index">
                    <div class="col-4">
                      <div class="why-us-box">
                        <span class='no-background skeleton'></span>
                        <h3 class="skeleton skeleton-title"></h3>
                        <ng-container *ngFor="let item of [].constructor(3); let i = index">
                          <p class="skeleton skeleton-text"></p>
                        </ng-container>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </ng-template>
      </div>

    </div>
  </div>
  <div id="footer">
    <div class="footer-copyright">
      <p class="copyright-text">{{ 'Copyright' | translate }} {{ '© [currentYear] [site_prefix]. All rights reserved.' | translate : { 'currentYear' : getCurrentYear(),'site_prefix':siteName } }}</p>
    </div>
  </div>
</section>